<template>
    <div class="steps__body__step steps__body__step--two">
        <div class="step-headline">Design wählen</div>
        <p>
            Konfigurieren Sie jetzt Ihr ausgewähltes Produkt, indem Sie zunächst ein Design wählen.<br>
            Wenn Sie sich doch für ein anderes Produkt entscheiden möchten, können Sie Ihre Auswahl auch einfach ändern.
            Klicken sie hierzu auf "Produkt ändern".<br><br>

            <strong>Wählen Sie aus einer von drei Optionen:</strong><br>Mit Filet gestalten <strong>oder</strong> mit
            Dekor gestalten
            <strong>oder</strong> ohne Design.
        </p>

        <div class="refinement">
            <!-- Selection of the Refinement options -->
            <div class="refinement__option"
                 v-for="option in refinementOptions"
                 :key="option.getHash()"
                 :class="{'active': isSelectedRefinement(option)}"
                 :id="option.getDescription()">
                <div>
                    <img :src="option.getThumbnailUrl()" :alt="option.getName()" @click="refinementClickHandler(option)">
                    <span class="od_top--right" v-if="typeof productAttributes[2] !== 'undefined'">{{productAttributes[2].options[0]}}</span>
                </div>
                <span class="refinement__option__name has-tooltip" @click="refinementOptionInfoClickHandler(option)">
                    {{ option.getName() }}
                </span>
            </div>
        </div>

        <!-- Filet color selection -->
        <div v-if="hasFiletRefinement">
            <div class="h6">Filetfarbe auswählen</div>
            <color-selector :attribute="filetColorAttribute"
                            :selected="selectedFiletColor"
                            @selected:color="filetColorSelectHandler"
            >
            </color-selector>
        </div>

        <!-- Decor selection -->
        <div v-if="hasDecorRefinement">
            <div class="h6">Dekor auswählen</div>

            <div class="refinement">
                <div class="refinement__option refinement__option--medium"
                     v-for="decor in decorOptions"
                     :key="decor.getId()"
                     :class="{'active': isSelectedDecor(decor)}"
                     @click="decorClickHandler(decor)"
                >
                    <div>
                        <img :src="decor.getThumbnailUrl()" v-if="decor.hasThumbnailUrl()"
                             :alt="decor.getName()">
                    </div>
                </div>
            </div>
        </div>


        <div class="step__controls">
            <a href="/gastro_geschirr_produkte/#panel-113-0-0-0" title="zurück zur Produktauswahl"
               class="button button--blue button--outline">
                <span>Produkt ändern</span>
            </a>

            <button type="button" class="button button--blue button--fill next-step"
                    @click="nextButtonClickHandler">
                <span>nächster Schritt</span>
            </button>
        </div>

        <!-- Decor Modal -->
        <ui-modal v-show="showDecorModal" @close:clicked="showDecorModal = false">
            <template v-slot:title>Mit Dekor gestalten</template>
            <template v-slot:content>
                <p>
                    Schlicht und minimalistisch, fröhlich-floral oder mit saisonalem Bezug? Entscheiden Sie sich hier
                    für eines unserer attraktiven Dekors. Achtung: Mit der Wahl eines Dekors können Sie keine weiteren
                    Elemente auf der Dekorfläche platzieren.
                </p>
            </template>
        </ui-modal>

        <!-- Filet Modal -->
        <ui-modal v-show="showFiletModal" @close:clicked="showFiletModal = false">
            <template v-slot:title>Mit Filet gestalten</template>
            <template v-slot:content>
                <p>
                    Wenn Sie Ihre individuelle Geschirrkollektion mit einer Filetierung versehen möchten, können Sie
                    hier aus unserer Palette ansprechende Farben dafür wählen.
                </p>
            </template>
        </ui-modal>

        <!-- None Modal -->
        <ui-modal v-show="showNoneModal" @close:clicked="showNoneModal = false">
            <template v-slot:title>Ohne Design</template>
            <template v-slot:content>
                <p>
                    Sie mögen es pur? Kein Problem – verzichten Sie mit dieser Option auf ein Design und fahren Sie
                    direkt fort mit der Personalisierung.
                </p>
            </template>
        </ui-modal>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from "vuex"
    import AttributeMaterialGroupValue          from "../../expivi/attributes/AttributeMaterialGroupValue"
    import Attribute                            from "../../expivi/attributes/Attribute"

    export default {
        name:     "Refinement",
        data:     function () {
            return {
                filetColorAttribute: null,
                decorAttributeId:    null,
                refinementOptions:   [],
                decorOptions:        [],
                showFiletModal:      false,
                showDecorModal:      false,
                showNoneModal:       false
            }
        },
        created:  function () {
            this.filetColorAttribute = this.$store.state.refinementAttributes.filterByType('mytw_conf_select_filetcolor')

            this.loadRefinementOptions()
                .loadDecorOptions()

            // HACK: first set refinement to first element, then change it to second one. This is required to properly init
            // customization positions for some products.
            this.$expiviReady.then(expivi => {
                // if (this.refinementOptions.length > 1) {
                //     let option = this.refinementOptions[0]
                //     this.updateRefinement(option)
                //     expivi.setProductAttribute(option.getAttributeId(), option.getId())
                //
                //     setTimeout(() => {
                //         let option = this.refinementOptions[1]
                //         // this.refinementClickHandler(option);
                //         this.updateRefinement(option)
                //         expivi.setProductAttribute(option.getAttributeId(), option.getId())
                //     }, 250);
                // }
            })

        },
        computed: {
            ...mapGetters('refinementConfiguration', ['hasFiletRefinement', 'hasDecorRefinement', 'hasRefinement', 'hasFiletColor', 'hasDecor']),
            ...mapState('refinementConfiguration', ['refinement', 'filetColor', 'decor']),
            ...mapState({
                productAttributes: state => state.product.attributes,
            }),

            selectedFiletColor: function () {
                if (this.hasFiletColor) {
                    return this.$store.state.refinementConfiguration.filetColor
                }

                return null
            }
        },
        methods:  {
            ...mapMutations('refinementConfiguration', ['updateRefinement', 'updateFiletColor', 'updateDecor']),

            /**
             * Handles the selection of the refinement option.
             */
            refinementClickHandler: function (option) {
                this.$expiviReady.then(expivi => {
                    this.updateRefinement(option)

                    this.addDataLayer({
                        'event': option.getDescription()
                    })

                    expivi.setProductAttribute(option.getAttributeId(), option.getId())
                })
            },

            /**
             * Handles the selection of the filet color.
             */
            filetColorSelectHandler: function (color) {
                this.updateFiletColor(color)
            },

            /**
             * Handles the selection of the decor.
             */
            decorClickHandler: function (decor) {
                this.$expiviReady.then(expivi => {
                    this.updateDecor(decor)
                    this.addDataLayer({
                        'event':        'mytw_decor_selected',
                        'Dekorauswahl': decor.getName()
                    })

                    expivi.setProductAttribute(this.decorAttributeId, decor.getId())
                })
            },

            /**
             * Loads the refinement options from the attributes tree
             */
            loadRefinementOptions: function () {
                let refinementOptionsNode = this.$store.state.refinementAttributes.filterByType('mytw_conf_select_refinement')

                if (refinementOptionsNode instanceof Attribute) {
                    if (refinementOptionsNode.hasAttributeValues()) {
                        this.refinementOptions = refinementOptionsNode.getAttributeValues()

                        if (!this.hasRefinement) {
                            let defaultRefinement = refinementOptionsNode.getDefaultAttributeValue()
                            this.updateRefinement(defaultRefinement)
                        }
                    } else {
                        throw new Error('Missing attribute values for the refinement options')
                    }
                } else {
                    throw new Error('Invalid filter result. Expected one node, but got array')
                }

                return this
            },

            /**
             * Loads the decor options from the attributes tree
             */
            loadDecorOptions: function () {
                let decorOptionsNode = this.$store.state.refinementAttributes.filterByType('mytw_conf_select_decor')

                if (decorOptionsNode instanceof Attribute) {
                    if (decorOptionsNode.hasAttributeValues()) {
                        let attributeValue    = decorOptionsNode.getAttributeValues()[0]
                        this.decorAttributeId = attributeValue.getAttributeId()

                        if (attributeValue instanceof AttributeMaterialGroupValue) {
                            this.decorOptions = attributeValue.getValuableMaterials()

                            if (!this.hasDecor) {
                                let defaultDecor = attributeValue.getDefaultValuableMaterial()
                                this.updateDecor(defaultDecor)
                            }
                        }
                    } else {
                        throw new Error('Missing attribute values for the decor node')
                    }
                } else {
                    throw new Error('Invalid filter result. Expected one node, but got array')
                }

                return this
            },

            /**
             * Displays the modals for the refinement options.
             */
            refinementOptionInfoClickHandler: function (option) {
                this.showFiletModal = false
                this.showDecorModal = false
                this.showNoneModal  = false

                switch (option.getDescription()) {
                    case 'mytw_conf_refinement_filet':
                        this.showFiletModal = true
                        break
                    case 'mytw_conf_refinement_decor':
                        this.showDecorModal = true
                        break
                    case 'mytw_conf_refinement_none':
                        this.showNoneModal = true
                        break
                }
            },

            /**
             * Verify if the selected refinement option is the currently selected option
             *
             * @returns {boolean}
             */
            isSelectedRefinement: function (option) {
                return this.hasRefinement ? this.refinement.getId() === option.getId() : false
            },

            /**
             * Verify if the given decor is the currently selected decor
             *
             * @returns {boolean}
             */
            isSelectedDecor: function (decor) {
                return this.hasDecor ? this.decor.getId() === decor.getId() : false
            },

            /**
             * Click handler for the Button to go to step 3.
             */
            nextButtonClickHandler: function () {
                this.addDataLayer({
                    'event': 'mytw_conf_step2_goto_step3',
                });

                this.$router.push({name: 'customizationType'})
            }
        }
    }
</script>

<style scoped>
    button {
        outline: none;
        cursor: pointer;
    }

    button:active {
        outline: none;
    }

    button:focus {
        outline: none;
    }
</style>
